export default "__VITE_ASSET__D$dHiajy__"